var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomsTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 132,
    viewBox: "0 0 163 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.017 -8.10119L118.939 -7.25098L138.808 41.4323L140.885 40.5821L121.017 -8.10119Z",
    fill: "url(#paint0_linear_3437_43324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.904 15.8219L190.339 14.2119L152.715 50.9038L154.28 52.5138L191.904 15.8219Z",
    fill: "url(#paint1_linear_3437_43324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6289 63.8582L89.9385 66.084L129.315 60.5911L129.005 58.3653L89.6289 63.8582Z",
    fill: "url(#paint2_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 34,
    width: 45,
    height: 46
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.335 78.4807C164.126 75.135 170.976 62.8504 167.635 51.0424C164.294 39.2344 152.027 32.3745 140.236 35.7203C128.445 39.066 121.595 51.3506 124.936 63.1585C128.277 74.9665 140.544 81.8265 152.335 78.4807Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3437_43324)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.335 78.4807C164.126 75.135 170.976 62.8504 167.635 51.0424C164.294 39.2344 152.027 32.3745 140.236 35.7203C128.445 39.066 121.595 51.3506 124.936 63.1585C128.277 74.9665 140.544 81.8265 152.335 78.4807Z",
    fill: "url(#paint3_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M134.38 73.8316C127.254 68.8987 124.552 60.4474 128.344 54.9607C132.136 49.4739 140.981 49.0237 148.107 53.9566C155.233 58.8895 157.935 67.3407 154.143 72.8275C150.351 78.3142 141.506 78.7645 134.38 73.8276V73.8316Z",
    fill: "url(#paint4_radial_3437_43324)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.303 62.8384C129.575 60.4795 130.128 58.2163 131.541 57.7779C132.953 57.3396 134.688 58.8976 135.416 61.2525C136.144 63.6113 135.591 65.8746 134.179 66.3129C132.766 66.7512 131.031 65.1932 130.303 62.8384Z",
    fill: "url(#paint5_radial_3437_43324)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.346 39.8315C151.322 38.2615 153.773 38.0503 156.817 39.3613C159.861 40.6722 162.347 43.0032 162.367 44.5731C162.391 46.143 159.94 46.3542 156.896 45.0433C153.853 43.7323 151.366 41.4014 151.346 39.8315Z",
    fill: "url(#paint6_radial_3437_43324)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: -8,
    width: 44,
    height: 44
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.647 29.5458C214.103 21.0777 214.103 7.34812 205.647 -1.12002C197.191 -9.58816 183.482 -9.58817 175.026 -1.12003C166.57 7.34811 166.57 21.0777 175.026 29.5458C183.482 38.014 197.191 38.014 205.647 29.5458Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3437_43324)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 52,
    width: 28,
    height: 29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7011 76.535C93.1146 71.1136 93.1146 62.3239 87.7011 56.9025C82.2876 51.4812 73.5105 51.4812 68.097 56.9025C62.6834 62.3239 62.6835 71.1136 68.097 76.535C73.5105 81.9563 82.2876 81.9563 87.7011 76.535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3437_43324)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7011 76.535C93.1146 71.1136 93.1146 62.3239 87.7011 56.9025C82.2876 51.4812 73.5105 51.4812 68.097 56.9025C62.6834 62.3239 62.6835 71.1136 68.097 76.535C73.5105 81.9563 82.2876 81.9563 87.7011 76.535Z",
    fill: "url(#paint7_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M70.181 76.9918C65.8122 73.7922 64.2605 68.4728 66.7194 65.1059C69.1743 61.7389 74.7089 61.6034 79.0776 64.803C83.4464 68.0027 84.9981 73.3221 82.5392 76.689C80.0843 80.056 74.5497 80.1914 70.181 76.9918Z",
    fill: "url(#paint8_radial_3437_43324)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8141 70.0583C67.3963 68.5721 67.7823 67.1695 68.6696 66.9185C69.5568 66.6674 70.6192 67.6676 71.033 69.1538C71.4508 70.6401 71.0648 72.0426 70.1775 72.2936C69.2903 72.5447 68.2279 71.5446 67.8141 70.0583Z",
    fill: "url(#paint9_radial_3437_43324)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3331 56.0334C81.345 55.0532 82.8769 54.9615 84.7588 55.8262C86.6368 56.6948 88.1528 58.193 88.1408 59.1732C88.1289 60.1534 86.5971 60.2451 84.7151 59.3804C82.8371 58.5118 81.3211 57.0136 81.3331 56.0334Z",
    fill: "url(#paint10_radial_3437_43324)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: -24,
    width: 43,
    height: 43
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.531 15.139C143.164 8.87424 145.901 -4.02473 139.646 -13.6716C133.39 -23.3186 120.51 -26.0603 110.877 -19.7955C101.244 -13.5308 98.5058 -0.631783 104.762 9.01513C111.017 18.662 123.898 21.4038 133.531 15.139Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3437_43324)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.531 15.139C143.164 8.87424 145.901 -4.02473 139.646 -13.6716C133.39 -23.3186 120.51 -26.0603 110.877 -19.7955C101.244 -13.5308 98.5058 -0.631783 104.762 9.01513C111.017 18.662 123.898 21.4038 133.531 15.139Z",
    fill: "url(#paint11_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M111.723 13.8726C104.852 9.54141 101.979 1.74361 105.305 -3.5479C108.632 -8.83941 116.896 -9.62039 123.767 -5.28916C130.639 -0.957931 133.511 6.83986 130.185 12.1354C126.859 17.4269 118.595 18.2079 111.723 13.8766V13.8726Z",
    fill: "url(#paint12_radial_3437_43324)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.464 3.74393C106.688 1.56835 107.113 -0.57933 108.418 -1.04552C109.723 -1.51172 111.411 -0.125093 112.19 2.05048C112.97 4.23004 112.541 6.37375 111.235 6.83994C109.93 7.30614 108.243 5.9195 107.464 3.74393Z",
    fill: "url(#paint13_radial_3437_43324)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8399 0.348267L25.3994 -0.981445L48.8697 8.92215L48.3102 10.2519L24.8399 0.348267Z",
    fill: "url(#paint14_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 28,
    height: 28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58508 4.27739C-1.5323 -1.42848 -1.05874 -10.2116 4.6428 -15.3403C10.3443 -20.469 19.1148 -20.0011 24.2322 -14.2953C29.3496 -8.58939 28.876 0.193761 23.1745 5.32245C17.4729 10.4511 8.70247 9.98326 3.58508 4.27739Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3437_43324)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58508 4.27739C-1.5323 -1.42848 -1.05874 -10.2116 4.6428 -15.3403C10.3443 -20.469 19.1148 -20.0011 24.2322 -14.2953C29.3496 -8.58939 28.876 0.193761 23.1745 5.32245C17.4729 10.4511 8.70247 9.98326 3.58508 4.27739Z",
    fill: "url(#paint15_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M26.6663 -3.47163C27.3844 -8.84658 24.6201 -13.6498 20.4907 -14.2006C16.3612 -14.7514 12.4327 -10.8402 11.7146 -5.4653C10.9965 -0.0903553 13.7609 4.71288 17.8903 5.26369C22.0197 5.8145 25.9483 1.90331 26.6645 -3.47478L26.6663 -3.47163Z",
    fill: "url(#paint16_radial_3437_43324)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3437_43324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 3,
    width: 17,
    height: 17
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6654 19.0104C46.6443 17.3001 44.771 12.6472 46.4812 8.61783C48.1914 4.58848 52.8376 2.70854 56.8587 4.41885C60.8799 6.12915 62.7532 10.782 61.043 14.8114C59.3328 18.8407 54.6866 20.7207 50.6654 19.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3437_43324)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6654 19.0104C46.6443 17.3001 44.771 12.6472 46.4812 8.61783C48.1914 4.58848 52.8376 2.70854 56.8587 4.41885C60.8799 6.12915 62.7532 10.782 61.043 14.8114C59.3328 18.8407 54.6866 20.7207 50.6654 19.0104Z",
    fill: "url(#paint17_linear_3437_43324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M61.0479 12.5925C61.4551 9.5271 59.8797 6.78656 57.5229 6.47675C55.1661 6.16695 52.9262 8.39299 52.519 11.4584C52.1087 14.5256 53.6872 17.2643 56.0441 17.5741C58.3996 17.8889 60.6407 15.6579 61.0479 12.5925Z",
    fill: "url(#paint18_radial_3437_43324)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1281 8.88089C58.6832 8.12354 57.9509 7.72525 57.4989 7.99501C57.0451 8.26162 57.0396 9.09502 57.4845 9.85237C57.9294 10.6097 58.6617 11.008 59.1136 10.7383C59.5656 10.4685 59.573 9.63825 59.1281 8.88089Z",
    fill: "url(#paint19_radial_3437_43324)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0237 8.92416C47.6159 8.5437 46.9705 9.13914 46.5887 10.2572C46.2036 11.377 46.2207 12.5913 46.6303 12.9749C47.0381 13.3553 47.6835 12.7599 48.0654 11.6419C48.4473 10.5239 48.4333 9.30776 48.0237 8.92416Z",
    fill: "url(#paint20_radial_3437_43324)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3437_43324",
    x1: 128.855,
    y1: 17.066,
    x2: 130.937,
    y2: 16.2164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3437_43324",
    x1: 171.469,
    y1: 32.5979,
    x2: 173.037,
    y2: 34.2057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3437_43324",
    x1: 109.599,
    y1: 63.3414,
    x2: 109.288,
    y2: 61.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3437_43324",
    x1: 130.365,
    y1: 72.5892,
    x2: 162.246,
    y2: 41.6635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#79A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6C89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#647AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6275FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#575BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4F4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4D44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4D44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4F49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#565AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6275FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6276FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6F90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#79A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#7FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.831 63.4937) rotate(-55.3687) scale(12.105 15.7285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C00B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2C00B5",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C00B5",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C00B5",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C00B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.901 62.1893) rotate(-17.2234) scale(2.67808 4.47773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-123.871 -77.1092) rotate(-156.73) scale(5.98725 2.60022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3437_43324",
    x1: 67.7068,
    y1: 76.1229,
    x2: 88.1191,
    y2: 57.3273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E57DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#DE6EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D65DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C941FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C030FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C02FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C840FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E782FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EC8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE91FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0712 70.4711) rotate(-53.8694) scale(7.56051 9.82434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BE2AFF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BE2AFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BE2AFF",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BE2AFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4505 69.7134) rotate(-15.7216) scale(1.67128 2.79448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-206.214 -75.2062) rotate(-155.228) scale(3.73837 1.62346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3437_43324",
    x1: 107.94,
    y1: 12.7969,
    x2: 136.522,
    y2: -17.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D9D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#CDC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C9BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BDADFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A691F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9880F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#987FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A690F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BBABFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C9BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D7CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E0D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.252 3.79004) rotate(-57.8573) scale(11.3418 14.7351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#947AF7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#947AF7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#947AF7",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#947AF7",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947AF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.835 2.93509) rotate(-19.7063) scale(2.50707 4.19148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3437_43324",
    x1: 37.1567,
    y1: 3.95995,
    x2: 36.5958,
    y2: 5.28912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3437_43324",
    x1: 27.7632,
    y1: -5.88873,
    x2: 0.0725598,
    y2: -4.17833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E57DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#DE6EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D65DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C941FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C030FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C02FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C840FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E782FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EC8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE91FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.664 -5.25539) rotate(-172.411) scale(7.56027 9.84208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BE2AFF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BE2AFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BE2AFF",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BE2AFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3437_43324",
    x1: 61.673,
    y1: 11.2093,
    x2: 45.8823,
    y2: 12.1844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B14EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#A236FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9827FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9522FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8C19EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7F0BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7602BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7602BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7E0ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8B18EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9522FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B2CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A73FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B14EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2083 11.3282) rotate(-172.411) scale(4.31072 5.61177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7400B9",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7400B9",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7400B9",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7400B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3919 9.50914) rotate(149.419) scale(0.954589 1.59411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3437_43324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.401 -318.346) rotate(-70.9859) scale(2.13475 0.924867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsTop);
export default __webpack_public_path__ + "static/media/atoms-top.8494d1a526f0f0962c3a6875c6b3803a.svg";
export { ForwardRef as ReactComponent };